import { createFileRoute } from '@tanstack/react-router';

import SensorVerificationStage from '@/ui/pages/Installer/stages/sensors/SensorVerificationStage';

// HS-1639: stage 4 — the server reads every sensor the device has.
export const Route = createFileRoute('/_dashboard/installer/installations/$id/sensor-verification')(
  {
    component: SensorVerificationStage,
  },
);
